import {
  BankPaymentStatementItem,
  MatchedPaymentRegisterItemWithBankDetails,
  PaymentRegisterItem,
  PaymentsOutput,
} from "./types";
import { createSheetData, downloadExcel } from "../../utils";
import {
  BankPaymentStatementHeaders,
  BankStatementTableHeaders,
  ClearedPaymentRegisterTableHeaders,
  MatchingBSHeadersInPR,
  PaymentRegisterHeaders,
  PaymentRegisterTableHeaders,
  PRRemarksToBSRemarksMapping,
} from "./paymentsContants";
import { addUniqueId, getDataCopy, readExcelFile } from "../../App";
import React from "react";

export function downloadPaymentOutput(paymentsOutput: PaymentsOutput) {
  const outstandingPaymentsSheetData = createSheetData(
    paymentsOutput.outstandingPRs,
    PaymentRegisterTableHeaders
  );
  const clearedPaymentsSheetData = createSheetData(
    paymentsOutput.clearedPayments,
    ClearedPaymentRegisterTableHeaders
  );
  const clearedBSSheetData = createSheetData(
    paymentsOutput.clearedBS,
    BankStatementTableHeaders
  );
  const outstandingBSSheetData = createSheetData(
    paymentsOutput.outstandingBS,
    BankStatementTableHeaders
  );
  const allPRsSheetData = createSheetData(
    paymentsOutput.allPRs,
    ClearedPaymentRegisterTableHeaders
  );
  downloadExcel({
    workSheets: [
      {
        workSheetData: outstandingPaymentsSheetData,
        worksheetName: "Outstanding Payments",
      },
      {
        workSheetData: clearedPaymentsSheetData,
        worksheetName: "Cleared Payments",
      },
      {
        workSheetData: allPRsSheetData,
        worksheetName: "All PRs",
      },
      {
        workSheetData: clearedBSSheetData,
        worksheetName: "Cleared BS",
      },
      {
        workSheetData: outstandingBSSheetData,
        worksheetName: "Outstanding BS",
      },
    ],

    fileName: `Payments Output Data ${new Date().toDateString()}.xlsx`,
  });
}

export function matchDisbursements(
  paymentRegisterData: PaymentRegisterItem[],
  bankPaymentStatementData: BankPaymentStatementItem[]
): PaymentsOutput {
  const paymentRegisterDataCopy: PaymentRegisterItem[] =
    getDataCopy<PaymentRegisterItem>(paymentRegisterData);
  const bankPaymentStatementDataCopy: BankPaymentStatementItem[] =
    getDataCopy<BankPaymentStatementItem>(bankPaymentStatementData);
  const matchedBankStatementIds: number[] = [];
  const matchedPRIds: number[] = [];
  const clearedPayments: MatchedPaymentRegisterItemWithBankDetails[] = [];
  paymentRegisterDataCopy.forEach((paymentRegisterRow: PaymentRegisterItem) => {
    const remarks: string = paymentRegisterRow[PaymentRegisterHeaders.Remarks];
    const instrumentId: number =
      paymentRegisterRow[PaymentRegisterHeaders.InstrumentId];
    const paymentAmount: number =
      paymentRegisterRow[PaymentRegisterHeaders.Withdrawals];
    const isCheck: boolean = isCheckPayment(instrumentId);
    let matchingBS: BankPaymentStatementItem | undefined;
    if (isCheck) {
      matchingBS =
        findMatchingPaymentRegisterItemInBankStatementsByInstrumentId(
          paymentRegisterRow,
          bankPaymentStatementData,
          matchedBankStatementIds
        );
    }
    if (!isCheck && !matchingBS) {
      matchingBS = findMatchingPaymentRegisterItemByRemarksAndAmount(
        paymentRegisterRow,
        bankPaymentStatementData,
        matchedBankStatementIds
      );
    }
    if (matchingBS) {
      const matchedPaymentRegisterItemWithBankDetails: MatchedPaymentRegisterItemWithBankDetails =
        {
          ...paymentRegisterRow,
          [MatchingBSHeadersInPR.Date]:
            matchingBS[BankPaymentStatementHeaders.Date],
          [MatchingBSHeadersInPR.InstrumentId]:
            matchingBS[BankPaymentStatementHeaders.InstrumentId],
          [MatchingBSHeadersInPR.Remarks]:
            matchingBS[BankPaymentStatementHeaders.Remarks],
          [MatchingBSHeadersInPR.Withdrawal]:
            matchingBS[BankPaymentStatementHeaders.Withdrawals],
        };
      clearedPayments.push(matchedPaymentRegisterItemWithBankDetails);
      matchedBankStatementIds.push(matchingBS[BankPaymentStatementHeaders.ID]);
      matchedPRIds.push(paymentRegisterRow[PaymentRegisterHeaders.ID]);
    }
  });
  const outstandingPRs = paymentRegisterDataCopy.filter(
    (paymentRegisterDatum: PaymentRegisterItem) => {
      const id = paymentRegisterDatum[PaymentRegisterHeaders.ID];
      return matchedPRIds.indexOf(id) === -1;
    }
  );
  const clearedBS: BankPaymentStatementItem[] =
    bankPaymentStatementDataCopy.filter(
      (statement: BankPaymentStatementItem) => {
        const id = statement[BankPaymentStatementHeaders.ID];
        return matchedBankStatementIds.includes(Number(id));
      }
    );
  const outstandingBS: BankPaymentStatementItem[] =
    bankPaymentStatementDataCopy.filter(
      (statement: BankPaymentStatementItem) => {
        const id = statement[BankPaymentStatementHeaders.ID];
        return !matchedBankStatementIds.includes(Number(id));
      }
    );
  /*createMatchingPRTableData(
                                                                                                      ClearedPaymentRegisterTableHeaders,
                                                                                                      clearedPayments
                                                                                                    );*/
  const allPRs: Partial<MatchedPaymentRegisterItemWithBankDetails>[] = [
    ...clearedPayments,
    ...outstandingPRs,
  ];
  const sortedPRs = allPRs.sort(function (a, b) {
    const IDa = a[PaymentRegisterHeaders.ID] || 0;
    const IDb = b[PaymentRegisterHeaders.ID] || 0;

    if (IDa < IDb) return -1;
    if (IDa > IDb) return 1;
    return 0;
  });

  console.log({
    clearedPayments,
    matchedBankStatementIds,
    matchedPRIds,
    outstandingPRs,
    clearedBS,
    outstandingBS,
    sortedPRs,
  });
  return {
    clearedPayments,
    matchedBankStatementIds,
    matchedPRIds,
    outstandingPRs,
    clearedBS,
    outstandingBS,
    allPRs: sortedPRs,
  };
}

function findMatchingPaymentRegisterItemInBankStatementsByInstrumentId(
  paymentRegisterRow: PaymentRegisterItem,
  bankPaymentStatementData: BankPaymentStatementItem[],
  matchedBankStatementIds: number[]
) {
  const prRemarks: string = paymentRegisterRow[PaymentRegisterHeaders.Remarks];
  const prInstrumentId: number =
    paymentRegisterRow[PaymentRegisterHeaders.InstrumentId];
  const paymentAmount: number =
    paymentRegisterRow[PaymentRegisterHeaders.Withdrawals];
  const matchingBS = bankPaymentStatementData.find(
    (bankPaymentStatementRow: BankPaymentStatementItem) => {
      const bsId: number =
        bankPaymentStatementRow[BankPaymentStatementHeaders.ID];
      const bsInstrumentId: string =
        bankPaymentStatementRow[BankPaymentStatementHeaders.InstrumentId];
      const hasAlreadyMatched: boolean = matchedBankStatementIds.includes(bsId);

      const bsInstrumentIdLast4Digits = Number(
        bsInstrumentId
          .toString()
          .substring(bsInstrumentId.length - 4, bsInstrumentId.length)
      );
      if (
        !hasAlreadyMatched &&
        bsInstrumentIdLast4Digits &&
        bsInstrumentIdLast4Digits === prInstrumentId
      ) {
        return true;
      }
    }
  );
  //console.log({ matchingBS, prInstrumentId });
  return matchingBS;
}

function findMatchingPaymentRegisterItemByRemarksAndAmount(
  paymentRegisterRow: PaymentRegisterItem,
  bankPaymentStatementData: BankPaymentStatementItem[],
  matchedBankStatementIds: number[]
): BankPaymentStatementItem | undefined {
  const prRemarks: string = paymentRegisterRow[PaymentRegisterHeaders.Remarks];
  const formattedPRRemarks: string[] = formatPRRemarksForComparison(prRemarks);
  if (paymentRegisterRow[PaymentRegisterHeaders.ID] === 1002) {
    console.log({ formattedPRRemarks });
  }

  const paymentAmount: number =
    paymentRegisterRow[PaymentRegisterHeaders.Withdrawals];
  const matchingBankStatementItem: BankPaymentStatementItem | undefined =
    bankPaymentStatementData.find(
      (bankPaymentStatementRow: BankPaymentStatementItem, index: number) => {
        const bsId: number =
          bankPaymentStatementRow[BankPaymentStatementHeaders.ID];
        const bsRemark: string =
          bankPaymentStatementRow[BankPaymentStatementHeaders.Remarks];
        const formattedBSRemarks = formatBSRemarksForComparison(bsRemark);
        const bsWithdrawal: number =
          bankPaymentStatementRow[BankPaymentStatementHeaders.Withdrawals];
        const hasAlreadyMatched: boolean =
          matchedBankStatementIds.includes(bsId);
        if (
          formattedPRRemarks[0] === "POPULARVEHICLESANDSERVI" &&
          paymentAmount === 54630.97 &&
          bankPaymentStatementRow[BankPaymentStatementHeaders.TransactionId] ===
            "S35018814"
        ) {
          debugger;
        }
        if (
          !hasAlreadyMatched &&
          formattedBSRemarks &&
          paymentAmount === bsWithdrawal
        ) {
          return !!formattedPRRemarks.find((formattedPRRemark: string) => {
            return formattedPRRemark.indexOf(formattedBSRemarks) > -1;
          });
        }
      }
    );
  return matchingBankStatementItem;
}

function isCheckPayment(instrumentId: number): boolean {
  return instrumentId.toString().length === 4;
}

export function replacePrefixFromRemarks(remarks: string = ""): string {
  return remarks.replace("Mr. ", "").replace("Mrs. ", "");
}

export function replaceCharactersInsideParenthesis(remarks: string) {
  return remarks.replace(/\(/gi, "(").replace(/ *\([^)]*\) */g, "");
}

export function replacePeriodWithSpace(remarks: string) {
  return remarks.replace(/\./g, " ");
}

export function removeFundTransferType(remarks: string) {
  return remarks.replace(/NEFTO-/g, " ").replace(/RTGSO-/g, " ");
}

export function removeExtraSpaces(remarks: string) {
  return remarks.replace(/\s\s+/g, " ").trim();
}

export function replaceBarNumbers(remarks: string) {
  return remarks.replace(/[(\d\/)|(\d\/)-\/d]+/g, "");
}

export function replaceNumberFollowedBySpaces(remarks: string) {
  return remarks.replace(/\s\d+/g, "");
}

export function removeSpaces(remarks: string) {
  return remarks.replace(/\s+/g, "").trim();
}

function formatPRRemarksForComparison(remarks: string = "") {
  const shouldConsole = remarks.indexOf(".K(LA00002564)") > -1;
  const formattedStrings = [];
  if (shouldConsole) {
    console.log({ remarks });
  }
  let formattedString = replacePrefixFromRemarks(remarks);
  if (shouldConsole) {
    console.log({ replacePrefixFromRemarks: formattedString });
  }
  formattedString = removeFundTransferType(formattedString);
  if (shouldConsole) {
    console.log({ removeFundTransferType: formattedString });
  }
  formattedString = replaceCharactersInsideParenthesis(formattedString);
  if (shouldConsole) {
    console.log({ replaceCharactersInsideParenthesis: formattedString });
  }
  formattedString = replacePeriodWithSpace(formattedString);
  if (shouldConsole) {
    console.log({ replacePeriodWithSpace: formattedString });
  }
  formattedString = replaceBarNumbers(formattedString);
  if (shouldConsole) {
    console.log({ replaceBarNumbers: formattedString });
  }
  formattedString = removeExtraSpaces(formattedString);
  if (shouldConsole) {
    console.log({ removeExtraSpaces: formattedString });
  }

  if (PRRemarksToBSRemarksMapping[formattedString]) {
    formattedStrings.push(
      removeSpaces(
        replaceNumberFollowedBySpaces(
          PRRemarksToBSRemarksMapping[formattedString]
        )
      )
    );
  }
  formattedStrings.push(removeSpaces(formattedString));
  if (shouldConsole) {
    console.log({ formattedStrings });
  }
  return formattedStrings;
}

let i = 2220;

function formatBSRemarksForComparison(remarks: string) {
  const shouldConsole =
    remarks === "NEFTO-BENOY BALAKRISHNAN 000456834102" ||
    remarks.indexOf("E.S.(1D4979254)111") > -1 ||
    i < 1000;
  let formattedString = removeFundTransferType(remarks);
  if (shouldConsole) {
    console.log({ removeFundTransferType: formattedString });
  }
  formattedString = replaceNumberFollowedBySpaces(formattedString);
  if (shouldConsole) {
    console.log({ replaceNumberFollowedBySpaces: formattedString });
  }
  formattedString = replacePeriodWithSpace(formattedString);
  if (shouldConsole) {
    console.log({ replacePeriodWithSpace: formattedString });
  }
  formattedString = removeExtraSpaces(formattedString);
  if (shouldConsole) {
    console.log({ removeExtraSpaces: formattedString });
  }
  formattedString = removeSpaces(formattedString);
  if (shouldConsole) {
    console.log({ removeSpaces: formattedString });
  }
  //console.log({ formattedString });
  i++;

  return formattedString.toUpperCase();
}

export async function handleGLFileSelection(
  fileChangeEvent: React.ChangeEvent<HTMLInputElement>
) {
  enum columnNames {
    ChequeNumber = "Cheque Number Ap",
    DebitAmount = "Debit Amount Ap",
    CreditAmount = "Credit Amount Ap",
  }

  const uniqueChequeNumbers: any = {};
  const glReports = (await readExcelFile(fileChangeEvent)) || [];
  glReports.forEach((glReport: any) => {
    const chequeNumber = glReport[columnNames.ChequeNumber];
    const debitAmount = Number(glReport[columnNames.DebitAmount]);
    const creditAmount = Number(glReport[columnNames.CreditAmount]);
    const netAmount = creditAmount - debitAmount;
    uniqueChequeNumbers[chequeNumber] = uniqueChequeNumbers[chequeNumber]
      ? uniqueChequeNumbers[chequeNumber] + netAmount
      : netAmount;
  });
  console.log({
    uniqueChequeNumbers,
  });
  const headers = ["Cheque Number", "Amount"];
  const dataRows = Object.entries(uniqueChequeNumbers);
  downloadExcel({
    workSheets: [
      {
        workSheetData: [headers, ...dataRows],
        worksheetName: "GL Report",
      },
    ],
    fileName: `GL Consolidated`,
  });
}

export async function handleMatchReportFileSelection(
  fileChangeEvent: React.ChangeEvent<HTMLInputElement>
) {
  enum columnNames {
    Withdrawals = "Withdrawals",
    BankW = "Bank Withdrawal",
    CreditAmount = "Credit Amount Ap",
  }

  const uniqueChequeNumbers: any = {};
  const allPr = (await readExcelFile(fileChangeEvent)) || [];

  const dataMismatch = allPr.filter((data: any) => {
    const prAmount = data["Withdrawals"];
    const bsAmount = data["Bank Withdrawal"];
    return prAmount !== bsAmount;
  });
  const dataMist = dataMismatch.map((obj: any) => {
    return Object.values(obj);
  });
  const firstData: any = allPr[0];
  console.log({
    firstData,
    dataMismatch,
    a: Object.keys(firstData),
  });
  downloadExcel({
    workSheets: [
      {
        workSheetData: [Object.keys(firstData), ...dataMist],
        worksheetName: "PR BS mismatch amount",
      },
    ],
    fileName: `All Match report amount mismatch.xlsx`,
  });
}
